import { defineMessages } from 'react-intl-next';

export default defineMessages({
	noKnowledgeAdded: {
		id: 'rovo-chat.view-agent.no-knowledge-added',
		defaultMessage: 'No custom knowledge sources',
		description: 'Message displayed when no knowledge is added to the Agent',
	},

	forgeKnowledgeDescription: {
		id: 'rovo-chat.view-agent.hidden-knowledge-description',
		defaultMessage: "Forge Agents built with code don't use typical knowledge sources",
		description:
			'Description of the knowledge section, this is displayed when knowledge is purposely hidden',
	},
} as const);
